module.exports = __webpack_public_path__ + "static/media/AMAPEmbratel.9f0e9a7d.svg";